<template>
    <div style="position: relative; height: 100vh; width: 100%">
        <!-- Tombol Kembali -->
        <div
            @click="goBack"
            style="
                position: absolute;
                top: 10px;
                left: 10px;
                width: 50px;
                height: 50px;
                background: white;
                border: 1px solid #ddd;
                border-radius: 50%;
                box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                z-index: 1000;
                color: grey;
            "
        >
            <ion-icon
                name="arrow-back-outline"
                style="font-size: 24px; color: grey"
            ></ion-icon>
        </div>
        <!-- Google Maps -->
        <div
            id="map"
            style="height: 90%; width: 100%; position: relative"
        ></div>

        <!-- Marker Tetap -->
        <div id="marker" :style="markerStyle"></div>

        <!-- Tombol Pencarian Lokasi -->
        <button
            @click="openSearchLocationModal()"
            style="
                position: absolute;
                top: 80px;
                right: 10px;
                width: 50px;
                height: 50px;
                background: white;
                border: 1px solid #ddd;
                border-radius: 50%;
                box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                z-index: 1000;
                color: grey;
            "
        >
            <ion-icon name="search" size="large"></ion-icon>
        </button>

        <!-- Tombol Lokasi Saat Ini -->
        <button
            @click="getCurrentLocation"
            style="
                position: absolute;
                top: 10px;
                right: 10px;
                width: 50px;
                height: 50px;
                background: white;
                border: 1px solid #ddd;
                border-radius: 50%;
                box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                z-index: 1000;
                color: grey;
            "
        >
            <ion-icon name="locate" size="large"></ion-icon>
        </button>

        <!-- Informasi Lokasi -->
        <div
            style="
                position: absolute;
                bottom: 0;
                width: 100%;
                background: #fff;
                padding: 20px;
                box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
                border-radius: 20px 20px 0 0;
            "
        >
            <!-- Loading -->
            <div
                class="text-center mt-5 mb-5"
                v-if="loading.searchLocationDetail"
            >
                <span
                    class="spinner-border spinner-border mr-1 text-primary"
                    role="status"
                    aria-hidden="true"
                ></span>
            </div>
            <div v-else>
                <h4 style="margin: 0">
                    {{ locationSearchDataSelected.address }}
                </h4>
                <p
                    style="
                        margin: 5px 0 15px;
                        font-size: 11px;
                        line-height: 15px;
                    "
                >
                    {{ locationSearchDataSelected.subAddress }}
                </p>
                <button
                    @click="selectLocation"
                    class="btn btn-primary btn-block btn-lg"
                >
                    Pilih Lokasi Ini
                </button>
            </div>
        </div>

        <!-- Modal Search Location -->
        <action-sheet
            ref="searchLocation"
            :title="'Cari Lokasi'"
            :inset="false"
            :content-full="true"
            :contentHeight="false"
            :fullDisplay="false"
            :btnClose="true"
            @close="closeSearchLocationModal()"
        >
            <div class="section mt-1 mb-1">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Cari"
                            v-model="querySearchLocation"
                            @input="inputQueryLocation()"
                        />
                        <i
                            class="clear-input"
                            @click="clearQuerySearchLocation()"
                        >
                            <ion-icon name="close-circle"></ion-icon>
                        </i>
                    </div>
                </div>
            </div>
            <!-- Loading -->
            <div
                class="text-center mt-5 pt-5 mb-5 pb-5"
                v-if="loading.searchLocation"
            >
                <span
                    class="spinner-border spinner-border mr-1 text-primary"
                    role="status"
                    aria-hidden="true"
                ></span>
            </div>
            <ul
                class="listview image-listview"
                v-else-if="locationSearchData.length > 0"
            >
                <li v-for="item in locationSearchData" :key="item.place_id">
                    <a
                        style="cursor: pointer"
                        class="item"
                        @click="
                            selectedLocation(
                                null,
                                null,
                                item.place_id,
                                'PlaceId'
                            )
                        "
                    >
                        <div class="in">
                            <div>
                                <b>{{
                                    item.structured_formatting.main_text
                                }}</b>
                                <footer>
                                    {{
                                        item.structured_formatting
                                            .secondary_text
                                    }}
                                </footer>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
            <div class="text-center p-1" v-else>
                <img
                    :src="require('@/assets/image/empty.webp')"
                    alt="404"
                    class="w-50"
                /><br />
                <h2 class="mb-1">Cari lokasi dulu yuk!</h2>
                <p style="line-height: 15px">
                    <small>
                        Masukkan nama jalan / perumahan / gedung di kolom atas
                        biar kami bisa bantu tentukan lokasimu.</small
                    >
                </p>
            </div>
        </action-sheet>
    </div>
</template>

<script>
    import $axios from '../api.js';
    import { Loader } from '@googlemaps/js-api-loader';
    import { mapState } from 'vuex';

    export default {
        props: ['referenceDataLocation', 'referencePage'],
        data() {
            return {
                map: null,
                address: 'Tamalarea Jaya',
                subAddress: 'Tamalarea, Kota Makassar, Sulawesi Selatan',
                additionalDetails: '',
                markerImage: require('@/assets/maker.svg'),
                isSearchModalOpen: false,
                autocomplete: null,
                querySearchLocation: '',
                locationSearchData: [],
                locationSearchDataSelected: {
                    placeId: '',
                    latitude: -5.141316825513414,
                    longitude: 119.49387495951134,
                    address: '',
                    subAddress: '',
                },
                loading: {
                    searchLocation: false,
                    searchLocationDetail: true,
                },
                selectLocationByPosition: true,
            };
        },
        computed: {
            ...mapState(['VUE_ENV']),
            markerStyle() {
                return {
                    position: 'absolute',
                    top: '45%',
                    left: '50%',
                    transform: 'translate(-50%, -100%)',
                    height: '46px',
                    width: '33px',
                    background: `url(${this.markerImage}) no-repeat center`,
                    backgroundSize: 'contain',
                    pointerEvents: 'none',
                };
            },
        },
        mounted() {
            const loader = new Loader({
                apiKey: this.VUE_ENV.VUE_APP_GMAPS_APIKEY,
                libraries: ['places'],
            });

            if (
                this.referenceDataLocation &&
                this.referenceDataLocation.latitude != '' &&
                this.referencePage
            ) {
                this.locationSearchDataSelected = this.referenceDataLocation;
            }

            loader.load().then(() => {
                // Inisialisasi Peta
                this.initMap();
            });
        },
        methods: {
            goBack() {
                // Tambahkan logika untuk kembali ke halaman sebelumnya
                this.$router.back(); // Jika menggunakan Vue Router
            },
            initMap() {
                const mapElement = document.getElementById('map');

                // Inisialisasi peta
                this.map = new google.maps.Map(mapElement, {
                    center: {
                        lat: this.locationSearchDataSelected.latitude,
                        lng: this.locationSearchDataSelected.longitude,
                    },
                    zoom: 16,
                    disableDefaultUI: true,
                    gestureHandling: 'greedy',
                });

                // Menonaktifkan Info Window pada POI
                this.map.addListener('click', event => {
                    if (event.placeId) {
                        // Hentikan aksi default jika klik pada POI
                        event.stop();
                    }
                });

                // Perbarui lokasi saat peta digese
                this.selectedLocation(
                    this.locationSearchDataSelected.latitude,
                    this.locationSearchDataSelected.longitude,
                    this.locationSearchDataSelected.placeId,
                    'LatLang'
                );

                this.map.addListener('center_changed', () => {
                    if (this.selectLocationByPosition) {
                        const center = this.map.getCenter();
                        this.locationSearchDataSelected.latitude = center.lat();
                        this.locationSearchDataSelected.longitude =
                            center.lng();
                        this.selectedLocation(
                            this.locationSearchDataSelected.latitude,
                            this.locationSearchDataSelected.longitude,
                            this.locationSearchDataSelected.placeId,
                            'LatLang'
                        );
                    }
                });

                // Panggil Geocoder untuk mendapatkan place_id
            },
            getComponent(components, type) {
                const component = components.find(c => c.types.includes(type));
                return component ? component.short_name : null;
            },
            updateAddress() {
                // Gunakan Geocoding API untuk mendapatkan nama alamat
                const geocoder = new google.maps.Geocoder();
                geocoder.geocode(
                    {
                        location: {
                            lat: this.locationSearchDataSelected.latitude,
                            lng: this.locationSearchDataSelected.longitude,
                        },
                    },
                    (results, status) => {
                        if (status === 'OK' && results[0]) {
                            const components = results[0].address_components;

                            // Ambil kelurahan dan kecamatan
                            const kelurahan = this.getComponent(
                                components,
                                'administrative_area_level_4'
                            );
                            const kecamatan = this.getComponent(
                                components,
                                'administrative_area_level_3'
                            );
                            const kota = this.getComponent(
                                components,
                                'administrative_area_level_2'
                            );
                            const provinsi = this.getComponent(
                                components,
                                'administrative_area_level_1'
                            );

                            // Set data ke Vue
                            this.address = `${
                                (kelurahan ? kelurahan : kecamatan) || ''
                            }`.trim();
                            this.subAddress = `${kelurahan || ''}, ${
                                kecamatan || ''
                            }, ${kota || ''}, ${provinsi || ''}`.trim();
                        }
                    }
                );
            },
            getCurrentLocation() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        position => {
                            const { latitude, longitude } = position.coords;
                            this.locationSearchDataSelected.latitude = latitude;
                            this.locationSearchDataSelected.longitude =
                                longitude;

                            // Perbarui peta ke lokasi saat ini
                            this.map.setCenter({
                                lat: latitude,
                                lng: longitude,
                            });
                            this.updateAddress();
                        },
                        error => {
                            console.error('Error mendapatkan lokasi:', error);
                            alert(
                                'Tidak dapat mengakses lokasi Anda. Mohon aktifkan GPS Anda dan coba lagi.'
                            );
                        }
                    );
                } else {
                    alert('Browser Anda tidak mendukung fitur Geolokasi.');
                }
            },
            openSearchLocationModal() {
                this.querySearchLocation = '';
                this.locationSearchData = [];
                let element = this.$refs.searchLocation.$el;
                window.$(element).modal('show');
            },
            closeSearchLocationModal() {
                let element = this.$refs.searchLocation.$el;
                window.$(element).modal('hide');
            },
            selectLocation() {
                if (this.referencePage) {
                    this.$router.push({
                        name: this.referencePage,
                        params: {
                            referenceDataLocation:
                                this.locationSearchDataSelected,
                        },
                    });
                }
            },

            inputQueryLocation() {
                if (this.time) {
                    clearTimeout(this.time);
                }
                this.time = setTimeout(() => {
                    this.loading.searchLocation = true;
                    this.getSearchLocationQuery();
                }, 500);
            },

            selectedLocation(latitude, longitude, placeId, selectedType) {
                if (selectedType == 'LatLang') {
                    this.locationSearchDataSelected.latitude = latitude;
                    this.locationSearchDataSelected.longitude = longitude;
                } else {
                    this.closeSearchLocationModal();
                    this.selectLocationByPosition = false;
                    this.locationSearchDataSelected.placeId = placeId;
                }

                if (this.time) {
                    clearTimeout(this.time);
                }
                this.time = setTimeout(() => {
                    this.loading.searchLocationDetail = true;
                    if (selectedType == 'LatLang') {
                        this.getSearchLocationDetailByLatLang();
                    } else {
                        this.getSearchLocationDetailByPlaceId();
                    }
                }, 500);
            },

            getSearchLocationQuery() {
                if (this.querySearchLocation != '') {
                    $axios
                        .get(
                            '/maps/searchLocationQuery?query=' +
                                this.querySearchLocation
                        )
                        .then(response => {
                            this.locationSearchData = response.data;
                            this.loading.searchLocation = false;
                        });
                } else {
                    this.locationSearchData = [];
                    this.loading.searchLocation = false;
                }
            },
            getSearchLocationDetailByLatLang() {
                if (
                    this.locationSearchDataSelected.longitude != '' &&
                    this.locationSearchDataSelected.latitude != ''
                ) {
                    $axios
                        .post(
                            '/maps/searchLocationDetailByLatLang',
                            this.locationSearchDataSelected
                        )
                        .then(response => {
                            const placeName = response.data.name;
                            const components =
                                response.data.location_details
                                    .address_components;

                            // Ambil kelurahan dan kecamatan
                            const kelurahan = this.getComponent(
                                components,
                                'administrative_area_level_4'
                            );
                            const kecamatan = this.getComponent(
                                components,
                                'administrative_area_level_3'
                            );
                            const kota = this.getComponent(
                                components,
                                'administrative_area_level_2'
                            );
                            const provinsi = this.getComponent(
                                components,
                                'administrative_area_level_1'
                            );

                            // Set data ke Vue
                            this.locationSearchDataSelected.address = `${
                                placeName
                                    ? placeName
                                    : (kelurahan ? kelurahan : kecamatan) || ''
                            }`.trim();
                            this.locationSearchDataSelected.subAddress = `${
                                kelurahan || ''
                            }, ${kecamatan || ''}, ${kota || ''}, ${
                                provinsi || ''
                            }`.trim();

                            this.loading.searchLocationDetail = false;
                        });
                } else {
                    this.locationSearchData = [];
                    this.loading.searchLocationDetail = false;
                }
            },
            getSearchLocationDetailByPlaceId() {
                if (this.locationSearchDataSelected.placeId != '') {
                    $axios
                        .post(
                            '/maps/searchLocationDetailByPlaceId',
                            this.locationSearchDataSelected
                        )
                        .then(response => {
                            const latitude =
                                response.data.location_details.geometry.location
                                    .lat;
                            const longitude =
                                response.data.location_details.geometry.location
                                    .lng;
                            const placeName = response.data.name;
                            const components =
                                response.data.location_details
                                    .address_components;

                            // Ambil kelurahan dan kecamatan
                            const kelurahan = this.getComponent(
                                components,
                                'administrative_area_level_4'
                            );
                            const kecamatan = this.getComponent(
                                components,
                                'administrative_area_level_3'
                            );
                            const kota = this.getComponent(
                                components,
                                'administrative_area_level_2'
                            );
                            const provinsi = this.getComponent(
                                components,
                                'administrative_area_level_1'
                            );

                            // Set data ke Vue
                            this.locationSearchDataSelected.address = `${
                                placeName
                                    ? placeName
                                    : (kelurahan ? kelurahan : kecamatan) || ''
                            }`.trim();
                            this.locationSearchDataSelected.subAddress = `${
                                kelurahan || ''
                            }, ${kecamatan || ''}, ${kota || ''}, ${
                                provinsi || ''
                            }`.trim();

                            this.locationSearchDataSelected.latitude = latitude;
                            this.locationSearchDataSelected.longitude =
                                longitude;

                            // set maker maps
                            this.map.setCenter({
                                lat: latitude,
                                lng: longitude,
                            });

                            this.loading.searchLocationDetail = false;
                            this.selectLocationByPosition = true;
                        });
                } else {
                    this.locationSearchData = [];
                    this.loading.searchLocationDetail = false;
                }
            },

            clearQuerySearchLocation() {
                this.querySearchLocation = '';
                this.inputQueryLocation();
            },
        },
    };
</script>

<style scoped>
    /* Gaya untuk tombol kembali */
    .back-button {
        position: absolute;
        top: 20px;
        left: 20px;
        background-color: white;
        border: none;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        cursor: pointer;
    }

    .back-button .arrow-left {
        border: solid black;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 5px;
        transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
    }

    .back-button:hover {
        background-color: #f0f0f0;
    }
</style>
